import { Injectable, Inject, forwardRef } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root'
})

export class TranslationService{

  constructor(
    @Inject(forwardRef(() => TranslateService)) private translate: TranslateService
  ){}

  useLanguage(language: string) {
    this.translate.use(language);
  }

  // Define language used to translate when changing language from footer component
  translateTo(language:string) {
    localStorage.setItem('language', language)
    this.useLanguage(language)
    
    // Reload page with graphics to rendered them in the selected language
    if (window.location.pathname === '/dashboard' || 
      window.location.pathname.includes('device-statistics') || 
      window.location.pathname === '/distributor-bins-model-dashboard') {
        window.location.reload();
    }
  }
}


